import { Pipe, PipeTransform } from '@angular/core';
import {dataUriToBlob, isDataUri} from '@softline/core';

@Pipe({
  name: 'stringToBlob'
})
export class StringToBlobPipe implements PipeTransform {
  transform(value: string | undefined): Blob | undefined {
    if (!isDataUri(value))
      return undefined;

    return dataUriToBlob(value)
  }
}
